import { enableProdMode, NgZone } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { COMMON_CONSTANTS } from '../src/app/common/core/common.constants';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import 'hammerjs';
import { SingleSpaProps, singleSpaPropsSubject } from './single-spa/single-spa-props';
import { Router, NavigationStart } from "@angular/router";
import {
  singleSpaAngular,
  getSingleSpaExtraProviders
} from "single-spa-angular";


if (environment.production) {
  enableProdMode();
}

const script = document.createElement('script');
// script.type = 'text/javascript';
script.charset = 'utf-8';
script.async = true;
script.innerHTML = ` window['adrum-start-time'] = new Date().getTime();
  (function(config){
      config.appKey = '` + environment.APPD_KEY + `';
      config.adrumExtUrlHttp = 'http://cdn.appdynamics.com';
      config.adrumExtUrlHttps = 'https://cdn.appdynamics.com';
      config.beaconUrlHttp = 'http://col.eum-appdynamics.com';
      config.beaconUrlHttps = 'https://col.eum-appdynamics.com';
      config.geoResolverUrlHttp = 'https://appd-geo.geo.t-mobile.com/geo/';
      config.geoResolverUrlHttps = 'https://appd-geo.geo.t-mobile.com/geo/';
      config.xd = {enable : true};
      config.spa = {"spa2": true};
  })(window['adrum-config'] || (window['adrum-config'] = {}));

  loadScrptAsync('` + COMMON_CONSTANTS.ADRUM_JS_PATH + `');

  function loadScrptAsync(url) {
    try {
        var d = document;
        var spt = d.createElement('script');
        spt.src = url;
        spt.async = !0;
        d.getElementsByTagName('script')[0].parentNode.appendChild(spt);
    } catch (ex) {
        console.log('loadScrptAsync' + ex);
    }
}
  `;
document.head.appendChild(script);

const lifecycles = singleSpaAngular({
  bootstrapFunction: (singleSpaProps: SingleSpaProps) => {
    singleSpaPropsSubject.next(singleSpaProps);
    return platformBrowserDynamic(getSingleSpaExtraProviders()).bootstrapModule(AppModule);
  },
  template: '<app-root />',
  Router,
  NavigationStart,
  NgZone,
  domElementGetter: (() => {
    const el = document.getElementById('microapp-content');
    if (el) {
      return () => el;
    }
    return undefined;
  })()
});

export const bootstrap = lifecycles.bootstrap;
export const mount = lifecycles.mount;
export const unmount = lifecycles.unmount;
